import type { PhaseTagType } from '@/frontend-types'
import { getPageUrl } from '@/helpers/breadcrumbs'
import { populated } from '@/helpers/populated'
import { transformImages, transformVenueStatus } from '@/helpers/transforms'
import type { VenueCardBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import type { CardFeatureProps } from '../atoms/CardFeature'
import FeatureCardBlock from '../blocks/FeatureCardBlock'

export const VenueCardConverter: JSXConverter<SerializedBlockNode<VenueCardBlock>> = ({ node }) => {
	const { page } = node.fields

	if (!populated(page) || !page.venue) {
		return null
	}

	const { status, city, region, photos, phase, excerpt } = page.venue

	const location = `${city} / ${region}`

	const images = transformImages(photos)

	const phaseTag: PhaseTagType = {
		phase: phase,
		icon: ['fas', 'timeline'],
	}

	const venueData: CardFeatureProps = {
		type: 'venue',
		title: page.title,
		category: transformVenueStatus(status),
		subtitle: location,
		excerpt: excerpt,
		images: images,
		phaseTag: phaseTag,
		url: getPageUrl(page),
	}

	return <FeatureCardBlock card={venueData} />
}
